import { axiosInstanceFgts } from "./axiosInstance";


interface DocumentUrlResponse {
  sasUrl: string;
  fileUrl: string;
}

export const getDocumentUrl = async (
  fileName: string
): Promise<DocumentUrlResponse> => {
  try {
    const urlRes = await axiosInstanceFgts.post('/api/generate-upload-url', {
      fileName: fileName,
    });

    return urlRes.data;
  } catch (error) {
    console.error("Erro ao obter a URL do documento:", error);
    throw error;
  }
};
